module.exports = __webpack_public_path__ + "img/article-5.a966cb55.jpg";